var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSweetTreats = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Donut--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Donut Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm8 9a1 1 0 1 1 -1 1 1 1 0 0 1 1 -1Zm-4.5 -6A1.5 1.5 0 1 1 14 4.5 1.5 1.5 0 0 1 15.5 3ZM12 8.5A3.5 3.5 0 1 1 8.5 12 3.5 3.5 0 0 1 12 8.5ZM8.5 4a1 1 0 1 1 -1 1 1 1 0 0 1 1 -1ZM4.75 7.5A1.25 1.25 0 1 1 3.5 8.75 1.25 1.25 0 0 1 4.75 7.5ZM12 22a10 10 0 0 1 -9.41 -6.6 0.5 0.5 0 0 1 0.11 -0.51 0.49 0.49 0 0 1 0.5 -0.15 5 5 0 0 0 1.45 0.2 5.38 5.38 0 0 0 2 -0.38 0.49 0.49 0 0 1 0.61 0.22 5.51 5.51 0 0 0 9.5 0 0.49 0.49 0 0 1 0.61 -0.22 5.38 5.38 0 0 0 2 0.38 5 5 0 0 0 1.45 -0.2 0.49 0.49 0 0 1 0.5 0.15 0.5 0.5 0 0 1 0.11 0.51A10 10 0 0 1 12 22Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSweetTreats);
export default ForwardRef;